import { X } from 'lucide-react';
import { Group, Stack } from '@folio/components/ui/flex';
import { Text } from '@folio/components/ui/text';
import { ThemeIcon } from '@folio/components/ui/theme-icon';

type BlockingErrorBannerProps = {
  message: string;
  title?: string;
};

export const BlockingErrorBanner = ({
  message,
  title = 'Souscription impossible',
}: BlockingErrorBannerProps) => {
  return (
    <Group align="start" gap={3} className="rounded-xl bg-destructive/5 px-4 py-3 shadow-sm">
      <ThemeIcon
        size="sm"
        radius="full"
        variant="filled"
        tone="destructive"
        className="self-center"
      >
        <X />
      </ThemeIcon>
      <Stack gap={0} className="gap-0.5">
        <Text size="sm" weight="semibold" className="text-destructive/70">
          {title}
        </Text>
        <Text size="sm" className="text-destructive/50">
          {message}
        </Text>
      </Stack>
    </Group>
  );
};
